import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.md};
  height: 100%;
  min-height: 0;
  padding: ${(props) => props.theme.spacing.lg};
  border: 1.5px solid
    ${(props) =>
      props.$selected ? props.theme.colors.celticBlue : props.theme.colors.dividerGray};
  border-radius: 12px;
  cursor: pointer;
  background: ${(props) => props.theme.colors.white};

  &:hover {
    border-color: ${(props) =>
      props.$selected ? props.theme.colors.celticBlue : props.theme.colors.clearGray};
  }
`;

export const SelectedStatus = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.sm};
  color: ${(props) => props.theme.colors.darkSpringGreen};

  svg,
  svg path {
    color: currentColor;
    fill: currentColor;
  }

  p,
  span[class] {
    color: ${(props) => props.theme.colors.darkSpringGreen} !important;
  }
`;

export const TopRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${(props) => props.theme.spacing.md};
`;

export const TitleWrapper = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
`;

export const AvatarSlot = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const AvatarIconOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  color: ${(props) =>
    props.$selected ? props.theme.colors.celticBlue : props.theme.colors.davysGrey};
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.spacing.xs};
  min-width: 0;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  margin-top: auto;
`;
